/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($brandNameId: ID!, $brandVideoLink: String!) {
    BrandVideoUpload(brandNameId: $brandNameId, brandVideoLink: $brandVideoLink) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
